import { makeStyles } from "@mui/styles";
import { fontSize } from "@mui/system";

export default makeStyles(() => ({
  '@global': {

    // ... global styles here

    body: {
      margin: 0,
      backgroundColor: "#373737",
    }
  },
  app: {
    
    height: '100%'
    
  },
  navbar: {
    position: "fixed !important",
    top: '0 !important',
  },
  
  image: {
    marginLeft: "15px !important",
  },
  carousel: {
    padding: "75px !important",
    margin: 'auto !important',
    //maxWidth: '70vw !important',
    
  },
  carouselImage: {
    margin: 'auto !important',
    objectFit: 'scale-down !important',
    backgroundColor: 'transparent !important',
    
    
    
  },
  "@keyframes load": {
    "0%": { opacity: 0 },
    "100%": { opacity: 1 },
  },
  footer: {
    backgroundColor: 'lightgray',
    minHeight: '20px',
    display: 'flex',
    justifyContent: "center",
    padding: '10px',
    
    position: 'fixed !important',
    bottom: 0,
    width: '100%'

  },
  
  about_container: {
    
    display: 'flex !important',
    alignItems: 'center !important',
    
  },
  about_me: {
    fontSize: '18px !important',
    padding: '100px !important',
    marginBottom: '25px !important',
    
  },
  shows_container: {
    
    display: 'flex !important',
    alignItems: 'center !important',
    
  },
  paper_legend: {
    display: 'flex !important',
    position: 'absolute !important',
    bottom: '0px !important',
    backgroundColor: 'rgba( 55,55,55,0.5) !important',
    padding: '10px',
    paddingLeft: '25px',
    width: '100vh',
    
    
    
    
  },
  legend_text: {
    fontWeight: '300 !important',
    color: 'whitesmoke !important',
    marginRight: '25px !important'
  }
  
}));
